import { Card, Stack } from "react-bootstrap";
import { CardTitle } from "../components/card_components";
import TableCellCurrency from "@/components/Table/cell_formats/TableCellCurrency";

export default function TotalDuesCard({ loanSummary }) {
  const items = [
    { label: "Principal", value: loanSummary?.principalDueAmount },
    { label: "Int_Fee", value: loanSummary?.interestDueAmount },
    { label: "Grace", value: loanSummary?.graceDueAmount },
    { label: "Penal", value: loanSummary?.penalDueAmount },
    { label: "Charges", value: loanSummary?.chargesDueAmount },
    { label: "Excess Amount", value: loanSummary?.excessAmount },
  ];

  return (
    <Card className="border-0 rounded-lg">
      <Card.Body className="p-4">
        <Stack gap={2}>
          {/* Header */}
          <Card.Title>
            <Stack direction="horizontal">
              <CardTitle title={"Total Dues"} csx={"me-auto"} />
            </Stack>
          </Card.Title>

          <TableCellCurrency
            value={loanSummary?.totalDueAmount || 0}
          />

          <hr className="my-1 border-primary-light" />

          <Stack gap={1}>
            {items.map((item) => (
              <div
                key={item.label}
                className="d-flex justify-content-between align-items-center"
              >
                <span className="text-sm text-gray-500">
                  {item.label}
                </span>
                <TableCellCurrency
                  value={item.value || 0}
                  size={3}
                />
              </div>
            ))}
          </Stack>
        </Stack>
      </Card.Body>
    </Card>
  );
}
